import {
  AlarmClock,
  ArrowLeftRight,
  Calendar,
  CalendarDays,
  CheckSquare,
  CircleDot,
  CornerDownLeft,
  FileText,
  Hash,
  KanbanSquare,
  LayoutGrid,
  Link,
  List,
  ListTree,
  Mail,
  MousePointerClick,
  Phone,
  Sigma,
  Table2,
  Tags,
  Type,
  User,
  Variable,
} from 'lucide-react';
import type { PropertyType, ViewType } from '@nexus/core';

export const TYPE_ICON: Record<PropertyType, typeof Type> = {
  text: Type,
  number: Hash,
  select: List,
  multi_select: Tags,
  status: CircleDot,
  date: Calendar,
  reminder: AlarmClock,
  checkbox: CheckSquare,
  person: User,
  url: Link,
  email: Mail,
  phone: Phone,
  page: FileText,
  relation: ArrowLeftRight,
  backlink: CornerDownLeft,
  rollup: Sigma,
  formula: Variable,
  button: MousePointerClick,
};

export const VIEW_ICON: Record<ViewType, typeof Table2> = {
  table: Table2,
  board: KanbanSquare,
  list: ListTree,
  calendar: CalendarDays,
  gallery: LayoutGrid,
};
